<div class="row">
  <div class="col">
    <div class="store-visibility-preferences" *ngIf="globals.currentUser">
      <mat-checkbox [(ngModel)]="showDisabledStores" (change)="storeVisibilityPreferencesChanged()" color="primary">{{ 'Visa inaktiverade butiker' | translate }}</mat-checkbox>
      <mat-checkbox [(ngModel)]="showSandboxStores" (change)="storeVisibilityPreferencesChanged()" color="primary">{{ 'Visa sandboxbutiker' | translate }}</mat-checkbox>
    </div>
  </div>
  <div class="col align-right">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Period' | translate }}</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [placeholder]="'Startdatum' | translate" [(ngModel)]="periodStart">
        <input matEndDate [placeholder]="'Slutdatum' | translate" [(ngModel)]="periodEnd">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    &nbsp;
    <button mat-raised-button color="primary" (click)="fetchStores()">{{ 'Uppdatera' | translate }}</button>
  </div>
</div>

<h3>ACE</h3>
<!-- NEW -->
<ng-container *ngIf="globals.currentUser">
  <table class="fullwidth styled compact stores">
    <tr>
      <th></th>
      <th colspan="6" class="align-center">{{ 'Ordrar' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th colspan="4" class="align-center">{{ 'Kostnader' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
      <th class="align-right">{{ 'Resultat' | translate }}</th>
    </tr>
    <tr class="sub-row">
      <th></th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Behandlas' | translate">pending_actions</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Redo' | translate">check</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad till print' | translate">print_add</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Printad' | translate">print_connect</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad' | translate">local_shipping</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Fel' | translate">error</span>
      </th>
      <th></th>
      <th class="align-right">
        <span>{{ 'Printfil' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Print' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Frakt' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Totalt' | translate }}</span>
      </th>
      <th></th>
      <th></th>
    </tr>
    <ng-container *ngFor="let store of aceStores">
      <tr class="store-row" *ngIf="shouldDisplayStore(store)" [ngClass]="{'disabled': store.disabled}">
        <ng-container *ngIf="storeSummaries[store._id]">
          <td>
            <a class="name ace-color" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}" target="_blank"
              [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
          </td>
          <td class="align-right" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PENDING)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.READY)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.QUEUED_FOR_PRINT)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PRINTED)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.SHIPPED)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.ERROR)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printFileCost)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printCost)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.shippingCost)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.total)}}</span>
          </td>
          <td class="align-right">
            <span *ngIf="storeSummaries[store._id]">{{getMargin(store)}}</span>
          </td>
          <td class="align-right">
            <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total -
              storeSummaries[store._id].costs.total)}}</span>
          </td>
        </ng-container>

        <ng-container *ngIf="!storeSummaries[store._id]">
          <td>
            <a class="name ace-color" target="_blank"
              [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
        </ng-container>
      </tr>
    </ng-container>
  </table>

  <br />
  <hr>
  <br />
  <h3>{{ 'Partners' | translate }}</h3>
  <table class="fullwidth styled compact stores">
    <tr>
      <th></th>
      <th colspan="6" class="align-center">{{ 'Ordrar' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th colspan="4" class="align-center">{{ 'Kostnader' | translate }}</th>
      <th colspan="3" class="align-center">{{ 'Krediter' | translate }}</th>
      <th colspan="2" class="align-right">{{ 'Resultat' | translate }}</th>
    </tr>
    <tr class="sub-row">
      <th></th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Behandlas' | translate">pending_actions</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Redo' | translate">check</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad till print' | translate">print_add</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Printad' | translate">print_connect</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad' | translate">local_shipping</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Fel' | translate">error</span>
      </th>
      <th></th>
      <th class="align-right">
        <span>{{ 'Printfil' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Print' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Frakt' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Totalt' | translate }}</span>
      </th>
      <th class="align-right">{{ 'Köpta' | translate }}</th>
      <th class="align-right">{{ 'Använda' | translate }}</th>
      <th class="align-right">{{ 'Återstående' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
      <th></th>
    </tr>
    <ng-container *ngFor="let store of partnerStores">
      <tr class="store-row" *ngIf="shouldDisplayStore(store)" [ngClass]="{'disabled': store.disabled}">
        <ng-container *ngIf="storeSummaries[store._id]">
          <td>
            <a class="name partner-color" target="_blank"
              [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}"
              [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
          </td>
          <td class="align-right" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PENDING)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.READY)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.QUEUED_FOR_PRINT)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PRINTED)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.SHIPPED)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.ERROR)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printFileCost)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printCost)}}</span>
          </td>
          <td class="align-right">
            <span class="small-text"
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.shippingCost)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.total)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].addedCredits.total)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(abs(storeSummaries[store._id].usedCredits.total))}}</span>
          </td>
          <td class="align-right">
            <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(store.credits)}}</span>
          </td>
          <td class="align-right">
            <span *ngIf="storeSummaries[store._id]">{{getPartnerMargin(store)}}</span>
          </td>
          <td class="align-right">
            <span
              *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(abs(storeSummaries[store._id].usedCredits.total-abs(storeSummaries[store._id].costs.total)))}}</span>
          </td>
        </ng-container>

        <ng-container *ngIf="!storeSummaries[store._id]">
          <td>
            <a class="name partner-color" target="_blank"   
            [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
           -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
            -
          </td>
          <td class="align-right">
           -
          </td>
        </ng-container>
      </tr>
    </ng-container>
  </table>
</ng-container>

<!--LEGACY -->
<ng-container *ngIf="!globals.currentUser">
  <table class="fullwidth styled compact stores">
    <tr>
      <th></th>
      <th colspan="6" class="align-center">{{ 'Ordrar' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th colspan="4" class="align-center">{{ 'Kostnader' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
      <th class="align-right">{{ 'Resultat' | translate }}</th>
    </tr>
    <tr class="sub-row">
      <th></th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Behandlas' | translate">pending_actions</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Redo' | translate">check</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad till print' | translate">print_add</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Printad' | translate">print_connect</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad' | translate">local_shipping</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Fel' | translate">error</span>
      </th>
      <th></th>
      <th class="align-right">
        <span>{{ 'Printfil' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Print' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Frakt' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Totalt' | translate }}</span>
      </th>
      <th></th>
      <th></th>
    </tr>
    <tr *ngFor="let store of aceStores" [ngClass]="{'disabled': store.disabled}">
      <td>
        <a class="name ace-color" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}" target="_blank"
          [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
      </td>
      <td class="align-right" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PENDING)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.READY)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.QUEUED_FOR_PRINT)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PRINTED)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.SHIPPED)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.ERROR)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printFileCost)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printCost)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.shippingCost)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.total)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{getMargin(store)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total -
          storeSummaries[store._id].costs.total)}}</span>
      </td>
    </tr>
  </table>

  <br />
  <hr>
  <br />
  <h3>{{ 'Partners' | translate }}</h3>
  <table class="fullwidth styled compact stores">
    <tr>
      <th></th>
      <th colspan="6" class="align-center">{{ 'Ordrar' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th colspan="4" class="align-center">{{ 'Kostnader' | translate }}</th>
      <th colspan="3" class="align-center">{{ 'Krediter' | translate }}</th>
      <th colspan="2" class="align-right">{{ 'Resultat' | translate }}</th>
    </tr>
    <tr class="sub-row">
      <th></th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Behandlas' | translate">pending_actions</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Redo' | translate">check</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad till print' | translate">print_add</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Printad' | translate">print_connect</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Skickad' | translate">local_shipping</span>
      </th>
      <th class="align-right">
        <span class="material-symbols-outlined" [title]="'Fel' | translate">error</span>
      </th>
      <th></th>
      <th class="align-right">
        <span>{{ 'Printfil' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Print' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Frakt' | translate }}</span>
      </th>
      <th class="align-right">
        <span>{{ 'Totalt' | translate }}</span>
      </th>
      <th class="align-right">{{ 'Köpta' | translate }}</th>
      <th class="align-right">{{ 'Använda' | translate }}</th>
      <th class="align-right">{{ 'Återstående' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
      <th></th>
    </tr>
    <tr *ngFor="let store of partnerStores" [ngClass]="{'disabled': store.disabled}">
      <td>
        <a class="name partner-color" target="_blank" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}"
          [routerLink]="[globals.panelUrl('/poster-orders', store)]">{{store.name}}</a>
      </td>
      <td class="align-right" [ngClass]="{'stale': storeSummaries[store._id].pendingIsStale}">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PENDING)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.READY)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.QUEUED_FOR_PRINT)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.PRINTED)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.SHIPPED)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.numberFormat(storeSummaries[store._id].orderStatuses.ERROR)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].sales.total)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printFileCost)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.printCost)}}</span>
      </td>
      <td class="align-right">
        <span class="small-text"
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.shippingCost)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].costs.total)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(storeSummaries[store._id].addedCredits.total)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(abs(storeSummaries[store._id].usedCredits.total))}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(store.credits)}}</span>
      </td>
      <td class="align-right">
        <span *ngIf="storeSummaries[store._id]">{{getPartnerMargin(store)}}</span>
      </td>
      <td class="align-right">
        <span
          *ngIf="storeSummaries[store._id]">{{utility.currencyFormat(abs(storeSummaries[store._id].usedCredits.total-abs(storeSummaries[store._id].costs.total)))}}</span>
      </td>
    </tr>
  </table>
</ng-container>

<br />
<hr>
<br />
<h3>{{ 'Leverantörer' | translate }}</h3>
<table class="fullwidth styled compact vendors">
  <tr>
    <th></th>
    <th class="align-right">{{ 'Kommission' | translate }}</th>
    <th></th>
  </tr>
  <ng-container *ngFor="let vendor of vendorCommissions | keyvalue">
    <tr>
      <td>{{vendor.key}}</td>
      <td class="align-right">{{utility.currencyFormat(vendor.value.total)}}</td>
      <td class="align-right">
        <span class="material-symbols-outlined clickable" [title]="'Visa mer' | translate"
          (click)="expandVendor(vendor.key)">list_alt</span>
      </td>
    </tr>
    <ng-container *ngIf="expandedVendor == vendor.key">
      <tr class="sub-row" *ngFor="let sku of vendor.value.sortedSkus">
        <td>{{sku[0]}}</td>
        <td class="align-right">
          {{utility.currencyFormat(sku[1], true)}}
        </td>
        <td></td>
      </tr>
    </ng-container>

  </ng-container>

</table>
<br />
<br />
<br />
<br />
